import {
    SupplierEnrollment,
    SupplierEnrollmentsResponse
} from '@lsq-frontend/remote-services/analytics-graphql/src/lib/utils/types';
import chartUtils, { dateSort } from './chart-utils';
import { ChartFilters, SupplierEnrollmentsChart } from './chart-types';
import { DateFormat } from '@lsq-frontend/common-ui';
import { format } from 'date-fns';

const getSupplierEnrollmentsConfig = (data: SupplierEnrollmentsChart) => {
    const chartConfig = {
        chart: {
            height: '430px'
        },
        title: {
            text: null
        },
        legend: { enabled: false },
        xAxis: [
            {
                categories: data.categories,
                title: {
                    text: null
                },
                labels: {
                    style: chartUtils.getTextStyle()
                }
            }
        ],
        yAxis: {
            min: 0,
            title: {
                text: '# of Enrolled Suppliers',
                style: chartUtils.getTextStyle()
            },
            labels: {
                style: chartUtils.getTextStyle()
            }
        },
        tooltip: {
            style: chartUtils.getTextStyle(),
            formatter: function (this: any) {
                const header = `<b>${this.x}</b><br/>`;
                const body = `# of Enrolled Suppliers: <b>${this.y}</b></br/>`;
                return '<div>' + header + body + '</div>';
            },
            shared: true
        },
        plotOptions: {},
        exporting: {
            enabled: false
        },
        colors: ['#6AC54A'],
        series: [
            {
                name: null,
                type: 'area',
                showInLegend: false,
                data: data.enrollments
            }
        ]
    };
    return chartConfig;
};

export default getSupplierEnrollmentsConfig;

export const GetSupplierEnrollmentsSchema = (
    data: SupplierEnrollmentsResponse,
    filters: ChartFilters
) => {
    if (data.enrollments.length === 0) {
        throw new Error('Empty data');
    }
    const source = data.enrollments.sort(dateSort);
    const categories = source.map((supplier: SupplierEnrollment) =>
        format(supplier.date, DateFormat.MonthNumberDashYear)
    );
    let enrollments = source.map((supplier: SupplierEnrollment) => supplier.count);
    let scalar = 0;
    enrollments = enrollments.map((countEnrollment: number) => {
        const accumulatedCount = countEnrollment + scalar;
        scalar = accumulatedCount;
        return accumulatedCount;
    });
    let startTrimCount = 0;
    for (const count of enrollments) {
        if (count === 0) {
            startTrimCount += 1;
        } else {
            break;
        }
    }
    const schema = getSupplierEnrollmentsConfig({
        categories: categories.slice(startTrimCount),
        enrollments: enrollments.slice(startTrimCount)
    });
    return schema;
};
